import { render, staticRenderFns } from "./studentProfile.vue?vue&type=template&id=e6ecae5a&scoped=true&"
import script from "./studentProfile.vue?vue&type=script&lang=js&"
export * from "./studentProfile.vue?vue&type=script&lang=js&"
import style0 from "./studentProfile.vue?vue&type=style&index=0&id=e6ecae5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ecae5a",
  null
  
)

export default component.exports